export const EndPoints = {
  LOG_IN: "api/Authentication/login",
  REGISTER: "api/Authentication/register",
  GET_CURRENT_SUBSCRIPTION: "api/Authentication/GetCurrentSubscription",
  REQUEST_PASSWORD_RESET: "api/UserManagement/RequestPasswordReset",
  RESET_PASSWORD: "api/UserManagement/ResetPassword",

  ML_CREATOR_GET_TRAINING_DATASETS: "api/MedMLCreator/GetTrainingDatasets",
  ML_CREATOR_ADD_TRAINING_DATASET: "api/MedMLCreator/AddTrainingDataset",
  ML_CREATOR_DOWNLOAD_TRAINING_DATASET:
    "api/MedMLCreator/DownloadTrainingDataset",
  ML_CREATOR_DOWNLOAD_CLEANED_TRAINING_DATASET:
    "api/MedMLCreator/DownloadCleanedTrainingDataset",
  ML_CREATOR_DELETE_TRAINING_DATASET: "api/MedMLCreator/DeleteTrainingDataset",
  ML_CREATOR_GET_TRAINING_FILE_DETAILS:
    "api/MedMLCreator/GetTrainingDatasetFileDetails",
  ML_CREATOR_GET_TRAINING_FILE_DATA: "api/MedMLCreator/GetDatasetsCosmosDB",
  ML_CREATOR_GET_TRAINING_MODELS: "api/MedMLCreator/GetTrainingModels",
  ML_CREATOR_GET_AI_MODEL_TYPES: "api/MedMLCreator/GetAIModelTypes",
  ML_CREATOR_GET_TRAINING_MODEL_DETAILS:
    "api/MedMLCreator/GetTrainingModelDetails",
  ML_CREATOR_GET_TRAINING_MODEL_SHARED_USERS:
    "api/MedMLCreator/GetTrainingModelSharedUsers",
  ML_CREATOR_DELETE_TRAINING_MODEL: "api/MedMLCreator/DeleteTrainingModel",
  ML_CREATOR_SHARE_TRAINING_MODEL_TOGGLE_DISABLED:
    "api/MedMLCreator/ShareTrainingModelToggleDisabled",
  ML_CREATOR_SHARE_TRAINING_MODEL: "api/MedMLCreator/ShareTrainingModel",
  ML_CREATOR_AI_ORCHESTRATOR_INIT_TRAIN:
    "api/MedMLCreator/AIOrchestratorInitTrain",
  ML_CREATOR_AI_MODEL_ALGORITHM_LIST: "api/MedMLCreator/AIModelAlgorithmList",

  ML_TESTER_GET_TESTING_DATASETS: "api/MedMLTester/GetTestingDatasets",
  ML_TESTER_ADD_TESTING_DATASET: "api/MedMLTester/AddTestingDataset",
  ML_TESTER_DOWNLOAD_TESTING_DATASET: "api/MedMLTester/DownloadTestingDataset",
  ML_TESTER_DELETE_TESTING_DATASET: "api/MedMLTester/DeleteTestingDataset",
  ML_TESTER_GET_TRAINING_FILE_DETAILS:
    "api/MedMLTester/GetTestingDatasetFileDetails",
  ML_TESTER_GET_TRAINING_FILE_DATA: "api/MedMLTester/GetDatasetsCosmosDB",
  ML_TESTER_AI_HEALTH_CHECK: "api/MedMLTester/AIHealthCheck",
  ML_TESTER_AI_PREDICT: "api/MedMLTester/AIPredict",
  ML_TESTER_GET_TRAINED_MODEL: "api/MedMLTester/GetTrainedModels",
  ML_TESTER_GET_PREDICTION_RESULTS: "api/MedMLTester/GetPredictionResults",
  ML_TESTER_DOWNLOAD_PREDICTION_RESULT:
    "api/MedMLTester/DownloadPredictionResult",
  ML_TESTER_DELETE_PREDICTION_RESULT: "api/MedMLTester/DeletePredictionResult",
  ML_TESTER_GET_PREDICTION_RESULT_DETAILS:
    "api/MedMLTester/GetPredictionResultDetails",
  ML_TESTER_PREDICT_SINGLE: "api/MedMLPrediction/AIPredictSingle",
  ML_TESTER_OPTIMIZE_SINGLE: "api/MedMLOptimisation/AIOptimiseSingle",

  USER_MANAGEMENT_GET_USERS: "api/UserManagement/GetAllUsers",
  USER_MANAGEMENT_ADD_USER: "api/UserManagement/AddUser",
  USER_MANAGEMENT_CHANGE_ROLE: "api/UserManagement/ChangeRole",
  USER_MANAGEMENT_ENABLE_USER: "api/UserManagement/EnableUser",
  USER_MANAGEMENT_GET_USER_SUBSCRIPTION: "api/Subscription/GetUserSubscription",
  SUBSCRIPTION_AVAILABLE_PLANS: "api/Subscription/GetAvailablePlans",
  SUBSCRIPTION_TIER_MANAGEMENT_PLANS: "api/Subscription/GetTierManagementPlans",
  SUBSCRIPTION_TIER_MANAGEMENT_UPDATE: "api/Subscription/UpdateTierPlan",
  SUBSCRIPTION_CURRENT_BILLING_STATE: "api/Subscription/GetCurrentBillingState",
  SUBSCRIPTION_USER_INVOICES: "api/Subscription/GetUserInvoices",
  SUBSCRIPTION_CREATE_PAID: "api/Subscription/CreateSubscription",
  SUBSCRIPTION_CUSTOMER_PORTAL: "api/Subscription/CreateCustomerPortalSession",
  SUBSCRIPTION_CANCEL_PAID: "api/Subscription/CancelPaidSubscription",
  SUBSCRIPTION_CONTINUE_PAID: "api/Subscription/ContinuePaidSubscription",

  GET_USER_PROFILE_INFO: "api/UserProfile/GetUserProfileInfo",
  UPDATE_PREFERRED_LANGUAGE: "api/UserProfile/UpdatePreferredLanguage",

  GET_LANGUAGES: "api/MedMLLanguage/GetLanguages",

  SEND_EMAIL_TO_SUPPORT: "api/Support/SendEmailToSupport",

  PREDICTION_GET_MODELS: "api/MedMLPrediction/GetModelsForPrediction",
  OPTIMIZATION_GET_MODELS: "api/MedMLOptimisation/GetModelsForOptimisation",

  PREDICTION_GET_PREDICTIONS: "api/MedMLPrediction/GetPredictions",
  DELETE_PREDICTION: "api/MedMLPrediction/DeletePrediction",
  GET_PREDICTION_DETAILS: "api/MedMLPrediction/GetPredictionDetails",

  OPTIMIZATION_GET_OPTIMIZATIONS: "api/MedMLOptimisation/GetOptimisations",
  DELETE_OPTIMIZATION: "api/MedMLOptimisation/DeleteOptimisation",
  GET_OPTIMIZATION_DETAILS: "api/MedMLOptimisation/GetOptimisationDetails",
};

export const AppRoutes = {
  LOG_IN: "/",
  REGISTER: "/register",
  ML_CREATOR: "/ml-creator",
  ML_CREATOR_OLD: "/ml-creator-old",
  ML_PREDICTION: "/ml-prediction",
  ML_OPTIMIZATION: "/ml-optimization",
  ML_TESTER: "/ml-tester",
  ML_TESTER_OLD: "/ml-tester-old",
  USER_MANAGEMENT: "/user-management",
  TIER_MANAGEMENT: "/tier-management",
  PROFILE: "/profile",
  COLOR_PICKER: "/color-picker",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  HELP: "/help",
  SUPPORT: "/support",
};
